export function formatPhoneNumberForText(phoneNumber: string) {
  const formatted = phoneNumber.replace(/^(\d{3})(\d{3})(\d{2})(\d{2})$/, '$1 $2-$3-$4')
  return formatted
}
